/**
 * A small status dot whose halo breathes (opacity and scale only), for "our
 * team is online" and "open now". The dot itself never blinks; the halo does.
 *
 * The keyframes ship inline with the dot rather than in an app stylesheet,
 * because the package also renders on the city sites. A visitor who asked
 * for reduced motion gets a still dot.
 */
const BREATHE_CSS = `
@keyframes mjBreathe { 0%, 100% { opacity: 0.45; transform: scale(1); } 50% { opacity: 0; transform: scale(2.2); } }
.mj-breathe { animation: mjBreathe 2.4s ease-in-out infinite; }
@media (prefers-reduced-motion: reduce) { .mj-breathe { animation: none; opacity: 0; } }
`;

export function BreathingDot({ color, still = false }: { color: string; still?: boolean }) {
  return (
    <span aria-hidden="true" className="relative inline-flex h-2 w-2 shrink-0">
      {!still && (
        <>
          <style>{BREATHE_CSS}</style>
          <span className="mj-breathe absolute inset-0 rounded-full" style={{ background: color }} />
        </>
      )}
      <span className="relative h-2 w-2 rounded-full" style={{ background: color }} />
    </span>
  );
}
